import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useCallback,
} from 'react';
import CustomConfirmDialog from './CustomConfirmDialog';

export type RenameConfirmDialogHandle = {
  show: () => void;
  hide: () => void;
};

type RenameConfirmDialogProps = {
  onConfirm?: () => void;
};

const RenameConfirmDialog = forwardRef<
  RenameConfirmDialogHandle,
  RenameConfirmDialogProps
>(({onConfirm}, ref) => {
  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  useImperativeHandle(
    ref,
    () => ({
      show: () => {
        setOpen(true);
      },
      hide: () => {
        setOpen(false);
      },
    }),
    []
  );

  const handleConfirm = useCallback(async () => {
    onConfirm?.();
    setOpen(false);
  }, [onConfirm]);

  return (
    <CustomConfirmDialog
      confirmType={'rename'}
      showDialog={open}
      onOk={handleConfirm}
      onCancel={handleClose}
    />
  );
});

export {RenameConfirmDialog};
